import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FiArrowUpRight } from "react-icons/fi";
import styles from "./parallaxCards.module.css"; // Import the CSS module
import {
  ARITST_NEXT_DOOR_ARENA_GIFTS,
  ARTIST_NEXT_DOOR_ARENA,
} from "../../utils/images";
import { useNavigate } from "react-router-dom";

export const ParallaxCards = () => {
  const navigate = useNavigate();
  const handleParticipateNowBtn = () => {
    navigate("/artist-next-door-arena");
  };
  return (
    <div className={styles.outerMostContainer}>
      <TextParallaxContent
        imgUrl={ARTIST_NEXT_DOOR_ARENA}
        heading="Introducing Artist Next Door Arena"
        handleParticipateNowBtn={handleParticipateNowBtn}
      >
        <FirstContent handleParticipateNowBtn={handleParticipateNowBtn} />
      </TextParallaxContent>
      <TextParallaxContent
        imgUrl={ARITST_NEXT_DOOR_ARENA_GIFTS}
        subheading="Fame and Cash Rewards!"
        heading="Win Exciting Prizes"
      >
        <SecondContent handleParticipateNowBtn={handleParticipateNowBtn} />
      </TextParallaxContent>
    </div>
  );
};

const IMG_PADDING = 12;

const TextParallaxContent = ({ imgUrl, subheading, heading, children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.relativeContainer}>
        <StickyImage imgUrl={imgUrl} />
        <OverlayCopy heading={heading} subheading={subheading} />
      </div>
      {children}
    </div>
  );
};

const StickyImage = ({ imgUrl }) => {
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["end end", "end start"],
  });

  const scale = useTransform(scrollYProgress, [0, 1], [1, 0.85]);
  const opacity = useTransform(scrollYProgress, [0, 1], [1, 0]);

  return (
    <motion.div
      style={{
        backgroundImage: `url(${imgUrl})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        height: `calc(100vh - ${IMG_PADDING * 2}px)`,
        top: IMG_PADDING,
        scale,
      }}
      ref={targetRef}
      className={styles.stickyImage}
    >
      <motion.div
        className={styles.overlay}
        style={{
          opacity,
        }}
      />
    </motion.div>
  );
};

const OverlayCopy = ({ subheading, heading }) => {
  const targetRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: targetRef,
    offset: ["start end", "end start"],
  });

  const y = useTransform(scrollYProgress, [0, 1], [250, -250]);
  const opacity = useTransform(scrollYProgress, [0.25, 0.5, 0.75], [0, 1, 0]);

  return (
    <motion.div
      style={{
        y,
        opacity,
      }}
      ref={targetRef}
      className={styles.overlayText}
    >
      <p className={styles.subheading}>{subheading}</p>
      <p className={styles.heading}>{heading}</p>
    </motion.div>
  );
};

const FirstContent = ({ handleParticipateNowBtn }) => (
  <div className={styles.contentWrapper}>
    <h2 className={styles.contentTitle}>
      Participate in India's only platform to grow your artistic talent
    </h2>
    <div className={styles.contentText}>
      <p className={styles.contentText}>
        {
          "To participate in the Artist Next Door Arena, users first need to sign "
        }
        {"up or log in to the website. Once logged in, they can update their "}
        {
          "profile and check out the current week’s theme or category, which could"
        }
        {
          "range from dancing to music or digital art. Artists then submit their "
        }
        {"work aligned with the theme, ensuring it meets any file and content "}
        {"guidelines set by the platform. "} <br /> <br />
        {" Once submitted, their entry will appear"}
        in the competition gallery, where the community can vote on their
        favorite pieces. The voting period lasts for a set time (typically a
        week), and users can vote for their favorite artist. Artists are
        encouraged to engage with others in the community to gain visibility and
        drive votes. <br /> <br />
        {" At the end of the voting period, the artist with the most"}
        votes in each category wins, earning rewards like prizes or badges. This
        process is repeated weekly, giving artists a chance to showcase their
        skills, compete, and build their presence on the platform.
      </p>
    </div>
    <div className={styles.participateNowContainer}>
      {" "}
      <button
        className={styles.signUpBtnArtist}
        onClick={handleParticipateNowBtn}
      >
        {"Participate Now"}
      </button>
    </div>
  </div>
);

const SecondContent = ({ handleParticipateNowBtn }) => (
  <div className={styles.contentWrapper}>
    <h2 className={styles.contentTitle}>Unlimited And Weekly Rewards!</h2>
    <div className={styles.contentText}>
      <p className={styles.content}>
        Participate Now to win cash prizes and fame!
      </p>
      <p className="mb-8 text-xl text-neutral-600 md:text-2xl">
        To encourage artists and make the competition more fun, a lot of prizes
        can be won by participating across various competitions on the website.
        <br />
        <br />
        Encourage your friends/followers on your social media to root for you in
        order to win. Prizes are subject to change according to company policy.
      </p>
      <div className={styles.participateNowContainer}>
        <button
          onClick={handleParticipateNowBtn}
          className={styles.signUpBtnUser}
        >
          {"Sign me up!"}
        </button>
      </div>
    </div>
  </div>
);

export default ParallaxCards;
